import { LayoutConfig } from '@spartacus/storefront';

export const layoutConfig: LayoutConfig = {
  layoutSlots: {
    header: {
      lg: {
        slots: ['SiteLogo', 'NavigationBar', 'HeaderLinks'],
      },
      slots: ['SiteLogo', 'HeaderLinks'],
    },
    footer: {
      slots: ['FooterLogo', 'SocialMedia', 'FooterNavigation'],
    },
    HisenseStoreLandingPageTemplate: {
      pageFold: 'Section1',
      slots: [
        'Section1',
        'Section2',
        'Section3',
        'Section4',
        'Section5',
      ],
    },
    SearchResultsListPageTemplate: {
      pageFold: 'SearchResultsListSlot',
      slots: [
        'TopContent',
        'BreadcrumbsSlot',
        'ProductLeftRefinements',
        'SearchResultsListSlot',
      ],
    },
    SearchResultsGridPageTemplate: {
      pageFold: 'SearchResultsGridSlot',
      slots: [
        'TopContent',
        'BreadcrumbsSlot',
        'ProductLeftRefinements',
        'SearchResultsGridSlot',
      ],
    },
    SearchResultsEmptyPageTemplate: {
      pageFold: 'MiddleContent',
      slots: [
        'TopContent',
        'BreadcrumbsSlot',
        'MiddleContent',
        'BottomContent',
      ],
    },
    ProductListPageTemplate: {
      pageFold: 'ProductListSlot',
      slots: [
        'Section1',
        'BreadcrumbsSlot',
        'ProductLeftRefinements',
        'ProductListSlot',
      ],
    },
    ProductGridPageTemplate: {
      pageFold: 'ProductGridSlot',
      slots: [
        'Section1',
        'BreadcrumbsSlot',
        'ProductLeftRefinements',
        'ProductGridSlot',
      ],
    },
    ProductDetailsPageTemplate: {
      pageFold: 'Section1',
      slots: [
        'BreadcrumbsSlot',
        'Summary',
        'AddToCart',
        'Section1',
        'Section2',
        'Section3',
        'Section4',
      ],
    },
    ProductDetailsWithoutCartPageTemplate: {
      pageFold: 'Section1',
      slots: [
        'SummaryWithoutCart',
        'Section1',
        'Section2',
        'Section3',
        'Section4',
      ],
    },
    CartPageTemplate: {
      pageFold: 'CenterRightContentSlot',
      slots: ['TopContent', 'EmptyCartMiddleContent', 'CenterRightContentSlot'],
    },
    CategoryPageTemplate: {
      pageFold: 'CenterRightContentSlot',
      slots: [
        'Section1',
        'Section2',
        'Section3',
        'Section4',
      ],
    },
    NewsListTemplate: {
      pageFold: 'TopContent',
      slots: ['TopContent', 'NewsList'],
    },
    NewsDetailsPageTemplate: {
      pageFold: 'Section2',
      slots: [
        'Section1',
        'Section2',
        'Section3',
        'Section4',
        'Section5',
      ],
    },
    ErrorPageTemplate: {
      pageFold: 'SideContent',
      slots: ['MiddleContent', 'BottomContent', 'SideContent'],
    },
    ContentPage1Template: {
      pageFold: 'Section3',
      slots: [
        'Section1',
        'Section2A',
        'Section2B',
        'Section3',
      ],
    },
    navigation: {
      lg: { slots: [] },
      slots: [
        'NavigationBar',
        'SiteContext',
        'SiteLinks',
      ],
    },
    LoginPageTemplate: {
      pageFold: 'BodyContent',
      slots: ['LeftContentSlot'],
    },
    MultiStepCheckoutSummaryPageTemplate: {
      pageFold: 'SideContent',
      slots: ['BodyContent', 'SideContent'],
    },
    OrderConfirmationPageTemplate: {
      pageFold: 'TopContent',
      slots: ['SideContent', 'TopContent', 'BodyContent'],
    },
    AccountPageTemplate: {
      pageFold: 'BodyContent',
      slots: [
        'BreadcrumbsSlot',
        'TopContent',
        'SideContent',
        'BodyContent',
        'BottomContent',
      ],
    },
    DealerListPageTemplate: {
      pageFold: 'DealerList',
      slots: ['DealerList'],
    },
    StoreFinderPageTemplate: {
      pageFold: 'MiddleContent',
      slots: ['MiddleContent'],
    },
  },
};
